import { render } from "./SearchHeader.vue?vue&type=template&id=3044e33c&scoped=true&ts=true"
import script from "./SearchHeader.vue?vue&type=script&lang=ts"
export * from "./SearchHeader.vue?vue&type=script&lang=ts"

import "./SearchHeader.vue?vue&type=style&index=0&id=3044e33c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3044e33c"]])

export default __exports__